<template>
  <div class="container">
    <div class="contract-box" v-if="false">
      <div class="b">
        <div class="contract-img-box">
          <div class="contract" v-for="(item, i) in contractList" :key="i">
            <img v-lazy="require('@/assets/lh.png')" class="img" alt="" />
            <div class="text">{{ item }}</div>
            <img v-lazy="require('@/assets/lh.png')" class="img" alt="" />
          </div>
        </div>
      </div>
      <div class="contract-img" @click="setIsContract">
        <img v-lazy="require('@/assets/x.png')" class="img" alt="" />
      </div>
    </div>
    <!-- 轮播 -->
    <!-- <div class="swiper-container">
      <a-carousel autoplay :autoplaySpeed="5000" :after-change="onChange">
        <div class="i_carousel_item" v-for="item in listImg" :key="item.id">
          <img v-lazy="item.img" alt="" />
        </div>
      </a-carousel>
    </div> -->
    <swiper
      @slide-change-transition-start="handleClickSlide"
      :options="swiperOption"
      ref="mySwiper"
    >
      <!-- <swiper-slide v-for="item in listImg" :key="item.id"
        ><a href="#/web/webproduct"
          ><img class="swiper-slide-img" v-lazy="item.img" alt="丰派收银" /></a
      ></swiper-slide> -->
      <swiper-slide>
        <div class="lb3">
          <img
            class="swiper-slide-img"
            src="@/assets/newdownload/lbbg5.png"
            :alt="$t('丰派收银')"
          />
          <div class="text-box">
            <p class="p1">{{ $t('丰派云POS 微商城') }}</p>
            <div class="p2">{{ $t('0成本、一分钟快速上线，丰派云POS微商城') }}</div>
            <div class="p2">{{ $t('让每一个商家都能拥有线上商城') }}</div>
            <div class="btn" @click.stop="go(5)">{{ $t('立即试用') }}</div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="lb3">
          <img
            class="swiper-slide-img"
            src="@/assets/lbbg4.png"
            :alt="$t('丰派收银')"
          />
          <div class="text-box">
            <p class="p1">{{ $t('自助收银') }}</p>
            <div class="p2">{{ $t('全新自助收银系统，帮助门店解决收银员人工问题。') }}</div>
            <div class="p2">{{ $t('降低收银成本，提高收银效率，提升门店容纳量。') }}</div>
            <div class="btn" @click.stop="go(4)">{{ $t('立即试用') }}</div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="lb3">
          <img
            class="swiper-slide-img"
            src="@/assets/lbbg3.png"
            :alt="$t('丰派收银')"
          />
          <div class="text-box">
            <p class="p1">{{ $t('丰派云POS') }}</p>
            <div class="p2">
              {{ $t('SaaS零售收银解决方案，数字零售平台，聚合多方外部平台，') }}
            </div>
            <div class="p2">
              {{ $t('开辟本地生活新战场，多端全场景快速收银，提升门店容纳量。') }}
            </div>
            <div class="btn" @click.stop="go(1)">{{ $t('立即试用') }}</div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="lb1">
          <img
            class="swiper-slide-img"
            src="@/assets/lbbg1.png"
            :alt="$t('丰派收银')"
          />
          <div class="text-box">
            <p class="p1">{{ $t('订货商城') }}</p>
            <div class="p2">
              {{ $t('订呗SaaS全场景供应链解决方案，以“数字化落地+数字供应平台”') }}
            </div>
            <div class="p2">{{ $t('为底座，构建数智技术驱动的一体化供应链服务 。') }}</div>
            <div class="btn" @click.stop="go(3)">{{ $t('立即试用') }}</div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="lb2">
          <img
            class="swiper-slide-img"
            src="@/assets/lbbg2.png"
            :alt="$t('丰派收银')"
          />
          <div class="text-box">
            <p class="p1">{{ $t('智慧零售') }}</p>
            <div class="p2">
              {{ $t('DIY商城模版，自定义装饰、千店千面凸显门店/品牌特色，') }}
            </div>
            <div class="p2">
              {{ $t('丰富的营销活动、会员人群管理、BI分析等，促进私域增长。') }}
            </div>
            <div class="btn" @click.stop="go(2)">{{ $t('立即试用') }}</div>
          </div>
        </div>
      </swiper-slide>

      <div class="swiper-pagination" slot="pagination"></div>
      <!-- <div class="swiper-button-prev" slot="button-prev">
        <img class="img" src="@/assets/left.png" alt="" />
      </div>
      <div class="swiper-button-next" slot="button-next">
        <img class="img" src="@/assets/right.png" alt="" />
      </div> -->
    </swiper>
    <div class="case-box">
      <div class="title-box">
        <div class="titie-text">
          <div class="titie-top">
            <img class="img" v-lazy="require('@/assets/ksbs.png')" alt="" />
            <span class="span">{{ $t('快速部署') }}</span>
          </div>
          <div class="titie-bottom">
            {{ $t('SaaS化版本轻实施、轻交付。无需专业培训，短时间内轻松上手') }}
          </div>
        </div>
        <div class="titie-text">
          <div class="titie-top">
            <img class="img" v-lazy="require('@/assets/sjaq.png')" alt="" />
            <span class="span">{{ $t('数据安全') }}</span>
          </div>
          <div class="titie-bottom">
            {{ $t('全站HTTPS加密，构建数据安全保护架构，云端部署，自动备份') }}
          </div>
        </div>
        <div class="titie-text">
          <div class="titie-top">
            <img class="img" v-lazy="require('@/assets/znfx.png')" alt="" />
            <span class="span">{{ $t('智能分析') }}</span>
          </div>
          <div class="titie-bottom">
            {{ $t('多维度数据呈现，零代码自定义分析，可视化数据视图') }}
          </div>
        </div>
        <div class="titie-text">
          <div class="titie-top">
            <img class="img" v-lazy="require('@/assets/yzfw.png')" alt="" />
            <span class="span">{{ $t('优质服务') }}</span>
          </div>
          <div class="titie-bottom">
            {{ $t('十年零售批发服务经验，一体化管家式服务，高响应，高效率') }}
          </div>
        </div>
      </div>
      <div class="case-text">
        <p class="pi1">{{ $t('服务海量客户的行业案例') }}</p>
        <p class="p2">{{ $t('完善的服务体系为企业数字化上云保驾护航') }}</p>
      </div>
      <div class="img-box">
        <img class="img" :src="require('@/assets/dq.png')" alt="" />
      </div>
      <div class="client-box">
        <div class="client-left">
          <div class="City-box">
            <div
              class="city"
              @click="setCityIndex(index)"
              v-for="(item, index) in cityList"
              :key="item.id"
              :class="cityIndex == item.id ? 'active' : ''"
            >
              {{ item.text }}
            </div>
          </div>
          <div class="city-area">
            <div class="area-left big margin40">
              <div class="area-text" v-for="item1 in row1" :key="item1.id">
                {{ item1.text }}
              </div>
            </div>
            <div class="area-left small margin40">
              <div class="area-text" v-for="item1 in row2" :key="item1.id">
                {{ item1.text }}
              </div>
            </div>
            <div class="area-left small">
              <div class="area-text" v-for="item1 in row3" :key="item1.id">
                {{ item1.text }}
              </div>
            </div>
            <div class="area-right">
              <img class="img" v-lazy="require('@/assets/crea.png')" alt="" />
            </div>
          </div>
        </div>
        <div class="client-righ">
          <div class="righ-text">
            <div class="text1">{{ $t('12年+') }}</div>
            <div class="btn1">{{ $t('技术积累') }}</div>
          </div>
          <div class="righ-text">
            <div class="text1">50+</div>
            <div class="btn1">{{ $t('覆盖行业') }}</div>
          </div>
          <div class="righ-text">
            <div class="text1">{{ $t('20W+') }}</div>
            <div class="btn1">{{ $t('用户体量') }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="plan-box">
      <!-- <swiper class="swiper-img-box" :options="swiperOption1" ref="mySwiper1">
        <div class="swiper-slide" v-for="item in partnerList" :key="item.id">
          <img class="img" v-lazy="item.img" alt="" />
          <div class="span">{{ item.title }}</div>
        </div>
      </swiper> -->
      <div class="partnerList">
        <div class="partner-box">
          <div class="partner1" v-for="item in partnerList" :key="item.id">
            <img class="img" v-lazy="item.img" alt="" />
            <div class="span">{{ item.title }}</div>
          </div>
        </div>
      </div>
      <div class="plan-text">
        <p class="p1">{{ $t('面向丰富业务场景的解决方案') }}</p>
        <p class="p2">
          {{ $t('提供多场景解决方案，满足各行业客户的业务需求，快速实现数字化转型') }}
        </p>
      </div>

      <swiper :options="swiperOption2" class="swiper-box2" ref="mySwiper">
        <div class="swiper-slide" v-for="item in tjList" :key="item.id">
          <img class="img" :src="item.img" alt="" />
          <div class="txt">{{ item.text }}</div>
        </div>
        <!-- <div class="swiper-button-prev" slot="button-prev">
          <img class="img" src="@/assets/left.png" alt="" />
        </div>
        <div class="swiper-button-next" slot="button-next">
          <img class="img" src="@/assets/right.png" alt="" />
        </div> -->
      </swiper>
    </div>
    <div class="app-box">
      <div class="text">{{ $t('丰派云POS·收银系统，助力企业管理+降本增效') }}</div>
      <div class="app-table-list">
        <div
          @mouseenter="setTableIndex(i)"
          class="app-table-box"
          :class="i == tableIndex ? 'active' : ''"
          v-for="(item, i) of tableList"
          :key="i"
        >
          <img
            v-lazy="i == tableIndex ? item.activeImg : item.img"
            alt=""
            class="table-img"
          />
          <div class="span-t">{{ item.text }}</div>
        </div>
      </div>
      <div class="app-item-list">
        <div
          class="app-item-box"
          :class="index == tableIndex ? 'active' : ''"
          v-for="(item, index) of itemList"
          :key="index"
        >
          <img v-lazy="item.img" class="item-img" alt="" />
          <div class="app-item-right">
            <div class="title-item">{{ item.text }}</div>
            <div class="span-list">
              <div
                class="span-item-box"
                v-for="(item1, i) of item.list"
                :key="i"
              >
                <div class="yuan"></div>
                <div class="txt">{{ item1 }}</div>
              </div>
            </div>
            <div class="xian"></div>
            <div class="btn-box">
              <div class="btn1" v-if="item.btn1" @click="goto">{{ item.btn1 }}</div>
              <div class="btn2" v-if="item.btn2" @click="gotoApp(tableIndex)">
                {{ item.btn2 }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 智能金字塔 -->
    <div class="znjzt-box">
      <img v-lazy="require('@/assets/znjzt.png')" class="znjzt-img" alt="" />
    </div>
    <div class="Introduction-box">
      <div class="Introduction-text">
        <p class="p1">{{ $t('轻松上手 简单好用') }}</p>
        <p class="p2">
          {{ $t('12年+的技术沉淀，为用户提供快速稳定、智能可靠的服务和产品') }}
        </p>
      </div>
      <div class="title-Introduction-box">
        <div class="Introduction1">
          <img v-lazy="require('@/assets/bg.png')" alt="" class="img" />
          <div class="saas-box">
            <div class="saas1-box">
              <div class="saas1">{{ $t('SaaS收银') }}</div>
              <div class="saas2">
                {{ $t('SaaS化解决方案，一键安装，无需培训，快速上手') }}
              </div>
            </div>

            <div class="btn-box">
              <div class="btn1" v-for="item in btn1List" :key="item">
                {{ item }}
              </div>
              <div style="width: 130px"></div>
            </div>
          </div>
        </div>
        <div class="Introduction1">
          <img v-lazy="require('@/assets/bg.png')" alt="" class="img" />
          <div class="saas-box">
            <div class="saas1-box">
              <div class="saas1">{{ $t('智慧零售') }}</div>
              <div class="saas2">
                {{ $t('以数字化为驱动力，实现线上线下一体化，企业再次赋能升级') }}
              </div>
            </div>
            <div class="btn-box">
              <div class="btn1" v-for="item in btn2List" :key="item">
                {{ item }}
              </div>
              <div style="width: 130px"></div>
            </div>
          </div>
        </div>
        <div class="Introduction1">
          <img v-lazy="require('@/assets/bg.png')" alt="" class="img" />
          <div class="saas-box">
            <div class="saas1-box">
              <div class="saas1">{{ $t('订货平台') }}</div>
              <div class="saas2">{{ $t('企业供应链数据化管理，B2B数智化管理') }}</div>
            </div>

            <div class="btn-box">
              <div class="btn1" v-for="item in btn3List" :key="item">
                {{ item }}
              </div>
              <div style="width: 130px"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="Serve-box">
      <div class="Serve-text">
        <div class="p1">{{ $t('智能商业服务生态') }}</div>
        <div class="p2">
          {{ $t('对接市面上众多优秀第三方服务供应商，为您提供多种类多方面的优质服务') }}
        </div>
      </div>
      <div class="serve-box-bom">
        <div class="serve-text" v-for="item in serveList" :key="item.id">
          <div class="im">
            <img v-lazy="item.img" class="img" alt="" />
          </div>
          <div class="title-t">{{ item.title }}</div>
          <div class="xian1"></div>
          <div class="span1-t">{{ item.p1 }}</div>
          <div class="span1-t">{{ item.p2 }}</div>
          <div class="span1-t">{{ item.p3 }}</div>
          <div class="span1-t">{{ item.p4 }}</div>
          <div class="span2-t">{{ item.p5 }}</div>
          <div class="span2-t span3-t">{{ item.p6 }}</div>
        </div>
      </div>
    </div>
    <div class="tryout-box">
      <img v-lazy="require('@/assets/zcbg.png')" class="img" alt="" />
      <div class="box">
        <div class="tryout-text">
          <div class="div1">
            {{ $t('立即注册，即可免费试用核心产品， 开启您的互联网运维经营之旅。') }}
          </div>
          <div class="div-btn" @click.stop="go(1)">{{ $t('免费试用') }}</div>
        </div>
        <div class="consultation">
          <div class="consultation-left">
            <div class="txt1">{{ $t('售前咨询') }}</div>
            <div class="txt3">{{ $t('专属客户经理，提供1v1购买咨询，产品介绍') }}</div>
            <div class="txt2">{{ $t('周一至周六 9:00 — 20:00') }}</div>
            <div class="txt4">{{ $t('咨询热线：400-086-1123') }}</div>
          </div>
          <div class="consultation-right">
            <img v-lazy="require('@/assets/qywx.png')" alt="" class="img" srcset="" />
          </div>
        </div>
      </div>
    </div>

    <!-- 优势内容 -->
    <!-- <div class="advantage">
      <div class="advantage-tit">我们的优势</div>
      <div class="advantage-content">
        <div
          class="advantage-item"
          v-for="item of advantageList"
          :key="item.id"
        >
          <div class="advantage-item-icon">
            <img v-lazy="item.img" :alt="item.title" />
          </div>
          <div class="advantage-item-tit">{{ item.title }}</div>
          <div class="advantage-item-tip">{{ item.tip }}</div>
        </div>
      </div>
    </div> -->
    <!-- 产品线 -->
    <!-- <div class="productLine wow animate__animated animate__slideInUp">
      <div class="productLine-tit wow animate__animated animate__slideInUp">
        产品线
      </div>
      <div class="productLine-content wow animate__animated animate__slideInUp">
        <div class="productLine-content-left">
          <div
            @click.stop="productLineMenu = 1"
            @mouseenter="productLineMenu = 1"
            :class="
              productLineMenu == 1
                ? 'productLine-content-left-item productLine-content-activite'
                : 'productLine-content-left-item'
            "
          >
            SaaS收银
          </div>
          <div
            @click.stop="productLineMenu = 2"
            @mouseenter="productLineMenu = 2"
            :class="
              productLineMenu == 2
                ? 'productLine-content-left-item productLine-content-activite'
                : 'productLine-content-left-item'
            "
          >
            智慧零售
          </div>
          <div
            @click.stop="productLineMenu = 3"
            @mouseenter="productLineMenu = 3"
            :class="
              productLineMenu == 3
                ? 'productLine-content-left-item productLine-content-activite'
                : 'productLine-content-left-item'
            "
          >
            订货平台
          </div>
        </div>
        <div class="productLine-content-line">
          <img
            v-show="productLineMenu == 1"
            v-lazy="require('@/assets/line1.png')"
            alt="丰派收银"
          />
          <img
            v-show="productLineMenu == 2"
            v-lazy="require('@/assets/line2.png')"
            alt="丰派收银"
          />
          <img
            v-show="productLineMenu == 3"
            v-lazy="require('@/assets/line3.png')"
            alt="丰派收银"
          />
        </div>
        <div class="productLine-content-right" v-show="productLineMenu == 1">
          <div class="productLine-content-right-tit">
            SaaS化解决方案，一键安装，无需培训，快速上手
          </div>
          <div class="productLine-content-right-content">
            <div
              class="productLine-content-right-content-item"
              v-for="item of productLine"
              :key="item.id"
            >
              <div class="productLine-content-right-content-item-icon">
                <img v-lazy="item.img" :alt="item.title" />
              </div>
              <div class="productLine-content-right-content-word">
                {{ item.title }}
              </div>
            </div>
          </div>
        </div>
        <div class="productLine-content-right" v-show="productLineMenu == 2">
          <div class="productLine-content-right-tit">
            以数字化为驱动力，实现线上线下一体化，企业再次赋能升级
          </div>
          <div class="productLine-content-right-content">
            <div
              class="productLine-content-right-content-item"
              v-for="item of productLine2"
              :key="item.id"
            >
              <div class="productLine-content-right-content-item-icon">
                <img v-lazy="item.img" :alt="item.title" />
              </div>
              <div class="productLine-content-right-content-word">
                {{ item.title }}
              </div>
            </div>
          </div>
        </div>
        <div class="productLine-content-right" v-show="productLineMenu == 3">
          <div class="productLine-content-right-tit">
            企业供应链数据化管理，B2B数智化管理
          </div>
          <div class="productLine-content-right-content">
            <div
              class="productLine-content-right-content-item"
              v-for="item of productLine3"
              :key="item.id"
            >
              <div class="productLine-content-right-content-item-icon">
                <img v-lazy="item.img" :alt="item.title" />
              </div>
              <div class="productLine-content-right-content-word">
                {{ item.title }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- 适用业态 -->
    <!-- <div class="applicableScene">
      <div class="applicableScene-tit wow animate__animated animate__slideInUp">
        适用业态
      </div>
      <div
        class="applicableScene-content wow animate__animated animate__slideInUp"
      >
        <div
          class="applicableScene-item"
          v-for="item of applicableScene.slice(0, 4)"
          :key="item.id"
        >
          <div class="applicableScene-item-icon">
            <img v-lazy="item.img" alt="丰派收银" />
          </div>
          <div class="applicableScene-item-word">{{ item.title }}</div>
        </div>
      </div>
      <div
        class="applicableScene-content wow animate__animated animate__slideInUp"
      >
        <div
          class="applicableScene-item"
          v-for="item of applicableScene.slice(4, 8)"
          :key="item.id"
        >
          <div class="applicableScene-item-icon">
            <img v-lazy="item.img" alt="丰派收银" />
          </div>
          <div class="applicableScene-item-word">{{ item.title }}</div>
        </div>
      </div>
    </div> -->
    <!-- 积累 -->
    <!-- <div class="accumulation">
      <div class="accumulation-content">
        <div
          class="accumulation-item wow animate__animated animate__slideInLeft"
        >
          <div class="accumulation-item-left">
            <img
              v-lazy="require('@/assets/accumulation1.png')"
              alt="丰派收银"
            />
          </div>
          <div class="accumulation-item-right">
            <div class="accumulation-item-word">技术积累</div>
            <div class="accumulation-item-focus">
              <countTo
                :startVal="scrollNum.one"
                :endVal="12"
                :duration="2000"
                suffix="年+"
                :autoplay="scrollautoplay"
              ></countTo>
            </div>
          </div>
        </div>
        <div
          class="accumulation-item wow animate__animated animate__slideInRight"
        >
          <div class="accumulation-item-left">
            <img
              v-lazy="require('@/assets/accumulation2.png')"
              alt="丰派收银"
            />
          </div>
          <div class="accumulation-item-right">
            <div class="accumulation-item-word">覆盖行业</div>
            <div class="accumulation-item-focus">
              <countTo
                :startVal="scrollNum.two"
                :endVal="50"
                :duration="2000"
                suffix="+"
                :autoplay="scrollautoplay"
              ></countTo>
            </div>
          </div>
        </div>
        <div
          class="accumulation-item wow animate__animated animate__slideInLeft"
        >
          <div class="accumulation-item-left">
            <img
              v-lazy="require('@/assets/accumulation3.png')"
              alt="丰派收银"
            />
          </div>
          <div class="accumulation-item-right">
            <div class="accumulation-item-word">销售地区</div>
            <div class="accumulation-item-focus">
              <countTo
                :startVal="scrollNum.three"
                :endVal="400"
                :duration="2000"
                suffix="+"
                :autoplay="scrollautoplay"
              ></countTo>
            </div>
          </div>
        </div>
        <div
          class="accumulation-item wow animate__animated animate__slideInRight"
        >
          <div class="accumulation-item-left">
            <img
              v-lazy="require('@/assets/accumulation4.png')"
              alt="丰派收银"
            />
          </div>
          <div class="accumulation-item-right">
            <div class="accumulation-item-word">用户体量</div>
            <div class="accumulation-item-focus">
              <countTo
                :startVal="scrollNum.four"
                :endVal="20"
                :duration="2000"
                suffix="W+"
                :autoplay="scrollautoplay"
              ></countTo>
            </div>
          </div>
        </div>
        <div class="accumulation-line"></div>
        <div class="accumulation-line2"></div>
        <div class="accumulation-line3"></div>
        <div class="accumulation-line4"></div>
      </div>
    </div> -->
    <!-- 伙伴 -->
    <!-- <div class="partner">
      <div class="partner-tit wow animate__animated animate__slideInUp">
        合作伙伴
      </div>
      <div class="partner-content wow animate__animated animate__slideInUp">
        <div
          class="partner-item"
          v-for="item in partnerList.slice(0, 5)"
          :key="item.id"
        >
          <div class="partner-item-icon">
            <img v-lazy="item.img" alt="丰派收银" />
          </div>
          <div class="partner-item-word">{{ item.title }}</div>
        </div>
      </div>
      <div class="partner-content wow animate__animated animate__slideInUp">
        <div
          class="partner-item"
          v-for="item in partnerList.slice(5, 10)"
          :key="item.id"
        >
          <div class="partner-item-icon">
            <img v-lazy="item.img" alt="丰派收银" />
          </div>
          <div class="partner-item-word">{{ item.title }}</div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import { t } from "@/i18n";

import countTo from "vue-count-to";
// import { swiper, swiperSlide } from "vue-awesome-swiper";
// import "swiper/dist/css/swiper.css";
export default {
  components: {
    // swiper:swiper,
    // swiperSlide:swiperSlide,
    countTo,
  },

  data() {
    return {
      isContract: true,
      contractList: [
        "恭喜某某某成功签约使用丰派收银系统1",
        "恭喜某某某成功签约使用丰派收银系统2",
        "恭喜某某某成功签约使用丰派收银系统3",
        "恭喜某某某成功签约使用丰派收银系统4",
        "恭喜某某某成功签约使用丰派收银系统56",
        "恭喜某某某成功签约使用丰派收银系统4",
      ],
      cityList: [
        {
          id: 0,
          text: t("广东"),
        },
        // {
        //   id: 1,
        //   text: "浙江",
        // },
        // {
        //   id: 2,
        //   text: "福建",
        // },
        // {
        //   id: 3,
        //   text: "江苏",
        // },
        // {
        //   id: 4,
        //   text: "湖南",
        // },
      ],
      cityIndex: 0,
      row1: [
        {
          id: 1,
          text: t("东莞市彩华商贸有限公司(悦合集)"),
        },
        {
          id: 4,
          text: t("深圳市趣吃汇贸易有限公司"),
        },
        {
          id: 7,
          text: t("广东省仆公英商业管理有限公司"),
        },
        {
          id: 10,
          text: t("深圳市兴吉成商贸有限公司"),
        },
        {
          id: 13,
          text: t("壹佳连锁便利店"),
        },
        {
          id: 16,
          text: t("喜多佳连锁便利店"),
        },
        {
          id: 19,
          text: t("每时每刻连锁便利店"),
        },
      ],
      row2: [
        {
          id: 2,
          text: t("阿里之门连锁便利店"),
        },
        {
          id: 5,
          text: t("喜惠福连锁便利店"),
        },

        {
          id: 8,
          text: t("美佳亲连锁便利店"),
        },
        {
          id: 11,
          text: t("幸福之家连锁便利店"),
        },
        {
          id: 14,
          text: t("汇客来连锁便利店"),
        },

        {
          id: 17,
          text: t("每尚惠连锁便利店"),
        },
        {
          id: 20,
          text: t("便利侠连锁便利店"),
        },
      ],
      row3: [
        {
          id: 3,
          text: t("快乐为民连锁便利店"),
        },
        {
          id: 6,
          text: t("万世淘连锁便利店"),
        },
        {
          id: 9,
          text: t("民尚连锁便利店"),
        },

        {
          id: 12,
          text: t("亿美力元连锁便利店"),
        },

        {
          id: 15,
          text: t("萌象优优连锁便利店"),
        },

        {
          id: 18,
          text: t("快购连锁便利店"),
        },
        {
          id: 21,
          text: "...",
        },
      ],
      serveList: [
        {
          id: 1,
          img: require("@/assets/fwsc.png"),
          title: t("服务市场"),
          p1: t("市场营销"),
          p2: t("店铺管理"),
          p3: t("硬件设备"),
          p4: t("装修模板"),
          p5: t("服务市场是基于对官方能力的补充和丰富，为满足商家多元化需求而打造的全场景一站式服务选购平台，"),
          p6: t("严选7大经营场景：市场营销、店铺管理、硬件设备、装修模板、运营管理、定制服务、企业服务，涵盖各类商家都在用的经营工具和服务。"),
        },
        {
          id: 2,
          img: require("@/assets/dzkf.png"),
          title: t("定制开发"),
          p1: t("服务号定制"),
          p2: t("企业号定制"),
          p3: t("小程序定制"),
          p4: t("个性化行业定制"),
          p5: t("以互联网定制开发为主营业务，专注微信服务号、企业号、微信公众平台开发和微信小程序等的微信开发服务。凭借专业的研发团队，在微信商城、会员、分销、营销等领域具有丰富的开发经验，全方位满足企业个性化需求，已为众多品牌提供专业定制开发服务。"),
        },
        {
          id: 3,
          img: require("@/assets/jjfa.png"),
          title: t("解决方案"),
          p1: t("小程序"),
          p2: t("大数据BI"),
          p3: t("云支付"),
          p4: t("第三方对接"),
          p5: t("服务市场是基于对官方能力的补充和丰富，为满足商家多元化需求而打造的全场景一站式服务选购平台。"),
          p6: t("严选7大经营场景：市场营销、店铺管理、硬件设备、装修模板、运营管理、定制服务、企业服务，涵盖各类商家都在用的经营工具和服务。"),
        },
        {
          id: 4,
          img: require("@/assets/zsfw.png"),
          title: t("专属服务"),
          p1: t("7×24小时服务"),
          p2: t("1v1大客户服务"),
          p3: t("运维服务"),
          p4: t("无忧退款"),
          p5: t("服务市场是基于对官方能力的补充和丰富，为满足商家多元化需求而打造的全场景一站式服务选购平台。"),
          p6: t("严选7大经营场景：市场营销、店铺管理、硬件设备、装修模板、运营管理、定制服务、企业服务，涵盖各类商家都在用的经营工具和服务。"),
        },
      ],

      scrollNum: {
        one: 12,
        two: 50,
        three: 400,
        four: 20,
      },
      scrolldomnum: true,
      scrollautoplay: false,
      btn1List: [
        t("一体化营销"),
        t("开发式API对接"),
        t("云端同步"),
        t("硬件兼容"),
        t("多终端覆盖"),
      ],
      btn2List: [t("特色营销"), t("店铺装修"), t("个性化配置"), t("智能组件")],
      btn3List: [t("高效管理"), t("数据安全"), t("资源生态化"), t("智能分析")],
      listImg: [
        // { img: require("@/assets/lb1.png"), id: 1 },
        { img: require("@/assets/lb4.png"), id: 4 },
        { img: require("@/assets/lb2.png"), id: 2 },
        { img: require("@/assets/lb3.png"), id: 3 },
      ],
      tjList: [
        { img: require("@/assets/sc.png"), id: 1, text: t("便利商超") },
        { img: require("@/assets/ms.png"), id: 2, text: t("餐饮美食") },
        { img: require("@/assets/sx.png"), id: 3, text: t("生鲜蔬果") },
        { img: require("@/assets/cw.png"), id: 4, text: t("宠物管理") },
        { img: require("@/assets/my.png"), id: 5, text: t("母婴亲子") },
        { img: require("@/assets/wj.png"), id: 6, text: t("精品文具") },
        { img: require("@/assets/fs.png"), id: 7, text: t("服饰鞋包") },
        { img: require("@/assets/sl.png"), id: 8, text: t("轻食沙拉") },
      ],
      tabList: [
        {
          table: t("丰派云POS"),
          img: require("@/assets/sc.png"),
          imgActive: require("@/assets/sc.png"),
        },
      ],
      swiperOption: {
        loop: true,
        // loopAdditionalSlides: 6,
        autoplay: {
          delay: 5000,
          // stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
        },
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      swiperOption1: {
        loop: true,
        slidesPerView: 10, // 加入这个属性
        // loopAdditionalSlides: 0,
        autoplay: {
          delay: 500,
          disableOnInteraction: false,
        },
      },
      swiperOption2: {
        loop: true,
        slidesPerView: "auto", //重要的
        // slidesPerView: 3.4, // 加入这个属性
        // loopAdditionalSlides: 6,
        autoplay: {
          delay: 2000,
          // stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },

      advantageList: [
        {
          img: require("@/assets/advantage1.png"),
          id: 1,
          title: t("快速部署"),
          tip: t("SaaS化版本轻实施、轻交付。无需专业培训，短时间内轻松上手"),
        },
        {
          img: require("@/assets/advantage2.png"),
          id: 2,
          title: t("数据安全"),
          tip: t("全站HTTPS加密，构建数据安全保护架构，云端部署，自动备份"),
        },
        {
          img: require("@/assets/advantage3.png"),
          id: 3,
          title: t("智能分析"),
          tip: t("多维度数据呈现，零代码自定义分析，可视化数据视图"),
        },
        {
          img: require("@/assets/advantage4.png"),
          id: 4,
          title: t("优质服务"),
          tip: t("十年零售批发服务经验，一体化管家式服务，高响应，高效率"),
        },
      ],
      productLine: [
        {
          img: require("@/assets/productLineIcon1.png"),
          id: 1,
          title: t("一体化营销"),
        },
        {
          img: require("@/assets/productLineIcon2.png"),
          id: 2,
          title: t("开放式API对接"),
        },
        {
          img: require("@/assets/productLineIcon3.png"),
          id: 3,
          title: t("云端同步"),
        },
        {
          img: require("@/assets/productLineIcon4.png"),
          id: 4,
          title: t("硬件兼容"),
        },
        {
          img: require("@/assets/productLineIcon5.png"),
          id: 5,
          title: t("多终端覆盖"),
        },
      ],
      productLine2: [
        {
          img: require("@/assets/productLineIcon2-1.png"),
          id: 1,
          title: t("特色营销"),
        },
        {
          img: require("@/assets/productLineIcon2-2.png"),
          id: 2,
          title: t("店铺装饰"),
        },
        {
          img: require("@/assets/productLineIcon2-3.png"),
          id: 3,
          title: t("个性化配置"),
        },
        {
          img: require("@/assets/productLineIcon2-4.png"),
          id: 4,
          title: t("智能组件"),
        },
      ],
      productLine3: [
        {
          img: require("@/assets/productLineIcon3-1.png"),
          id: 1,
          title: t("高效管理"),
        },
        {
          img: require("@/assets/productLineIcon3-2.png"),
          id: 2,
          title: t("数据安全"),
        },
        {
          img: require("@/assets/productLineIcon3-3.png"),
          id: 3,
          title: t("资源生态化"),
        },
        {
          img: require("@/assets/productLineIcon3-4.png"),
          id: 4,
          title: t("智能分析"),
        },
      ],
      productLineMenu: 1,
      applicableScene: [
        {
          img: require("@/assets/applicableScene1.png"),
          id: 1,
          title: t("便利商超"),
        },
        {
          img: require("@/assets/applicableScene2.png"),
          id: 2,
          title: t("餐饮美食"),
        },
        {
          img: require("@/assets/applicableScene3.png"),
          id: 3,
          title: t("生鲜蔬果"),
        },
        {
          img: require("@/assets/applicableScene4.png"),
          id: 4,
          title: t("宠物管理"),
        },
        {
          img: require("@/assets/applicableScene5.png"),
          id: 5,
          title: t("母婴亲子"),
        },
        {
          img: require("@/assets/applicableScene6.png"),
          id: 6,
          title: t("精品文具"),
        },
        {
          img: require("@/assets/applicableScene7.png"),
          id: 7,
          title: t("服饰鞋包"),
        },
        {
          img: require("@/assets/applicableScene8.png"),
          id: 8,
          title: t("轻食沙拉"),
        },
      ],
      partnerList: [
        {
          img: require("@/assets/partner13.png"),
          id: 26,
          title: t("悦合集"),
        },
        {
          img: require("@/assets/partner14.png"),
          id: 27,
          title: t("壹家便利"),
        },
        {
          img: require("@/assets/partner15.png"),
          id: 28,
          title: t("兴吉成商贸"),
        },
        {
          img: require("@/assets/partner16.png"),
          id: 29,
          title: t("喜多佳"),
        },
        {
          img: require("@/assets/partner17.png"),
          id: 30,
          title: t("趣吃汇"),
        },
        {
          img: require("@/assets/partner18.png"),
          id: 31,
          title: t("仆公英"),
        },
        {
          img: require("@/assets/partner1.png"),
          id: 1,
          title: t("阿里之门"),
        },
        {
          img: require("@/assets/partner2.png"),
          id: 2,
          title: t("快乐为民"),
        },
        {
          img: require("@/assets/partner3.png"),
          id: 3,
          title: t("民尚"),
        },
        {
          img: require("@/assets/partner4.png"),
          id: 4,
          title: t("每时每刻"),
        },
        {
          img: require("@/assets/partner5.png"),
          id: 5,
          title: t("惠发小厨"),
        },
        {
          img: require("@/assets/partner6.png"),
          id: 6,
          title: t("万世淘"),
        },
        {
          img: require("@/assets/partner7.png"),
          id: 7,
          title: t("萌象优优"),
        },
        {
          img: require("@/assets/partner8.png"),
          id: 8,
          title: t("汇客来"),
        },
        {
          img: require("@/assets/partner9.png"),
          id: 9,
          title: t("美佳亲"),
        },
        {
          img: require("@/assets/partner10.png"),
          id: 10,
          title: t("川猫"),
        },
        {
          img: require("@/assets/partner11.png"),
          id: 11,
          title: t("喜士福"),
        },
        {
          img: require("@/assets/partner12.png"),
          id: 51,
          title: t("幸福之家"),
        },

        {
          img: require("@/assets/partner1.png"),
          id: 12,
          title: t("阿里之门"),
        },
        {
          img: require("@/assets/partner2.png"),
          id: 13,
          title: t("快乐为民"),
        },
        {
          img: require("@/assets/partner3.png"),
          id: 14,
          title: t("民尚"),
        },
        {
          img: require("@/assets/partner4.png"),
          id: 15,
          title: t("每时每刻"),
        },
        {
          img: require("@/assets/partner5.png"),
          id: 16,
          title: t("惠发小厨"),
        },
        {
          img: require("@/assets/partner6.png"),
          id: 17,
          title: t("万世淘"),
        },
        {
          img: require("@/assets/partner7.png"),
          id: 18,
          title: t("萌象优优"),
        },
        {
          img: require("@/assets/partner8.png"),
          id: 19,
          title: t("汇客来"),
        },
        {
          img: require("@/assets/partner9.png"),
          id: 20,
          title: t("美佳亲"),
        },
        {
          img: require("@/assets/partner10.png"),
          id: 21,
          title: t("川猫"),
        },
        {
          img: require("@/assets/partner11.png"),
          id: 23,
          title: t("喜士福"),
        },
        {
          img: require("@/assets/partner12.png"),
          id: 25,
          title: t("幸福之家"),
        },

        // {
        //   img: require("@/assets/partner1.png"),
        //   id: 31,
        //   title: "阿里之门",
        // },
        // {
        //   img: require("@/assets/partner2.png"),
        //   id: 32,
        //   title: "快乐为民",
        // },
        // {
        //   img: require("@/assets/partner3.png"),
        //   id: 33,
        //   title: "民尚",
        // },
        // {
        //   img: require("@/assets/partner4.png"),
        //   id: 34,
        //   title: "每时每刻 ",
        // },
        // {
        //   img: require("@/assets/partner5.png"),
        //   id: 35,
        //   title: "惠发小厨",
        // },
        // {
        //   img: require("@/assets/partner6.png"),
        //   id: 36,
        //   title: "万世淘",
        // },
        // {
        //   img: require("@/assets/partner7.png"),
        //   id: 37,
        //   title: "萌象优优",
        // },
        // {
        //   img: require("@/assets/partner8.png"),
        //   id: 38,
        //   title: "汇客来 ",
        // },
        // {
        //   img: require("@/assets/partner9.png"),
        //   id: 39,
        //   title: "美佳亲 ",
        // },
        // {
        //   img: require("@/assets/partner10.png"),
        //   id: 40,
        //   title: "川猫 ",
        // },
      ],
      tableIndex: 0,
      tableList: [
        {
          img: require("@/assets/tab/logo.png"),
          activeImg: require("@/assets/tab/logo-1.png"),
          text: t("丰派云POS"),
        },
        {
          img: require("@/assets/tab/zzsy.png"),
          activeImg: require("@/assets/tab/zzsy-1.png"),
          text: t("自助收银"),
        },
        {
          img: require("@/assets/tab/wsc.png"),
          activeImg: require("@/assets/tab/wsc-1.png"),
          text: t("微商城"),
        },
        {
          img: require("@/assets/tab/yddht.png"),
          activeImg: require("@/assets/tab/yddht-1.png"),
          text: t("移动端后台"),
        },
        {
          img: require("@/assets/tab/webht.png"),
          activeImg: require("@/assets/tab/webht-1.png"),
          text: t("WEB后台"),
        },
        {
          img: require("@/assets/tab/dls.png"),
          activeImg: require("@/assets/tab/dls-1.png"),
          text: t("代理商应用"),
        },
      ],
      itemList: [
        {
          img: require("@/assets/tab/fpypos.png"),
          text: t("丰派云POS，专注零售领域的新零售SaaS系统"),
          list: [
            t("支持POS称重收银一体"),
            t("进销存管理、全渠道营销"),
            t("主流外卖平台对接"),
            t("多种纬度的业务数据分析"),
          ],
          btn1: t("免费体验"),
          btn2: t("了解更多"),
        },
        {
          img: require("@/assets/tab/zzsypos.png"),
          text: t("自助收银，降本增效、让收银更简单"),
          list: [
            t("有效减少收银排队时间"),
            t("智能识别，快速支付"),
            t("操作简单、兼容性高"),
            t("降低部署费用、人工成本"),
          ],
          btn1: t("免费体验"),
          btn2: t("了解更多"),
        },
        {
          img: require("@/assets/tab/wscpos.png"),
          text: t("联动线上线下，助力门店快速增长"),
          list: [
            t("线上线下联动，多渠道获客拉新"),
            t("总部统一管理，门店灵活运营"),
            t("多平台微商城，持续销售与转化"),
            t("实时同步沉淀客户信息"),
          ],
          btn1: t("免费体验"),
          btn2: t("了解更多"),
        },
        {
          img: require("@/assets/tab/yddpos.png"),
          text: t("移动端手机管理后台，随时随地管理收银"),
          list: [
            t("告别设备约束，随时随地管理"),
            t("手机收银，应对突发状况"),
            t("实时查看经营数据、分析报告"),
            t("商品销售风向标、了解行业动向"),
          ],
          btn1: t("免费体验"),
        },
        {
          img: require("@/assets/tab/webpos.png"),
          text: t("联动线上线下，助力门店快速增长"),
          list: [
            t("线上线下联动，多渠道获客拉新"),
            t("总部统一管理，门店灵活运营"),
            t("多平台微商城，持续销售与转化"),
            t("实时同步沉淀客户信息"),
          ],
          btn1: t("免费体验"),
        },
        {
          img: require("@/assets/tab/dlspos.png"),
          text: t("丰派云POS·代理商平台，管理好帮手"),
          list: [
            t("线上线下联动，多渠道获客拉新"),
            t("总部统一管理，门店灵活运营"),
            t("多平台微商城，持续销售与转化"),
            t("实时同步沉淀客户信息"),
          ],

        },
      ],
    };
  },
  activated() {
    window.addEventListener("scroll", this.myIscroll);
    this.scrolldomnum = true;
    this.scrollautoplay = false;
    this.scrollNum = this.$options.data().scrollNum;

    this.$nextTick(() => {
      this.$wow.init();
    });
  },
  deactivated() {
    window.removeEventListener("scroll", this.myIscroll);
  },
  methods: {
    setTableIndex(i) {
      this.tableIndex = i;
    },
    goto() {
      this.$router.push({ path: "/web/webdownload" });
    },
    gotoApp(i) {
      console.log(i)
      switch (i) {
        case 0:
      console.log(i)
          this.$router.push({ path: "/web/webproduct" });
          break;
        case 1:
          this.$router.push({ path: "/web/webproductauto" });
          break;
        case 2:
          this.$router.push({ path: "/web/webproductwx" });
          break;
      }
    },
    go(index) {
      if (index == 1) {
        location.href = "https://www.xyjpos.com/fpPos/#/login";
      } else if (index == 2) {
        // location.href = "https://gb.fp1123.com/#/login";
        window.open("https://gb.fp1123.com/#/login");
      } else if (index == 3) {
        // location.href = "https://db.fp1123.com/admin/#/login";
        window.open("https://db.fp1123.com/admin/#/login");
      } else if (index == 5) {
        window.open("https://www.fp1123.com/fpPos/#/microMall/mallSituation");
      } else {
        window.alert("请耐心等待,产品的推出");
      }
    },
    setIsContract() {
      this.isContract = false;
    },
    setCityIndex(value) {
      this.cityIndex = value;
    },
    onChange(a, b, c) {
      console.log(a, b, c);
    },
    handleClickSlide(item) {
      // this.current = item.realIndex;
    },
    myIscroll() {
      let hx = document.documentElement.scrollTop || document.body.scrollTop;
      if (hx > 1700 && this.scrolldomnum) {
        this.scrolldomnum = false;
        this.scrollautoplay = true;
        this.scrollNum.one = 0;
        this.scrollNum.two = 0;
        this.scrollNum.three = 0;
        this.scrollNum.four = 0;
        // console.error("滚。。。。",this.scrollautoplay);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.container {
  position: relative;
  z-index: 0;
  width: 100%;
  min-width: 1420px;
  background: #fff;
  top: 64px;
}

.contract-box {
  width: 100%;
  height: 44px;
  background: rgba(255, 255, 255, 0.9);
  position: relative;
  .b {
    position: absolute;
    width: 100%;
    overflow: hidden;
    .contract-img-box {
      width: 4600px;
      height: 44px;
      overflow: hidden;
      animation: move1 24s linear infinite normal;
      display: flex;
      flex-wrap: nowrap;
      .contract {
        height: 44px;
        display: flex;
        align-items: center;
        // justify-content: space-between;
        margin-right: 300px;
        .text {
          font-size: 16px;
          line-height: 24px;
        }
        .img {
          width: 44px;
          height: 44px;
        }
      }
    }
  }

  .contract-img {
    cursor: pointer;
    position: absolute;
    right: 0%;
    width: 80px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    .img {
      width: 22.14px;
      height: 22.14px;
    }
  }
}
@keyframes move1 {
  0% {
    transform: translateX(0px);
  }
  100% {
    transform: translateX(-3400px);
  }
}
.swiper-container {
  width: 100%;
  min-width: 1420px;
  // height: 560px;
  // overflow: hidden;
  /deep/ .swiper-pagination-bullet {
    width: 24px;
    height: 6px;

    display: inline-block;
    border-radius: 4px;
    background: #000;
    opacity: 0.3;
  }
  /deep/.swiper-pagination-bullets {
    left: 50%;
    width: 1420px;
    transform: translateX(-50%);
    bottom: 15%;
    text-align: left;
  }
  /deep/ .swiper-pagination-bullet-active {
    background: #336fff;
    opacity: 1;
  }
  .swiper-button-prev {
    margin-left: 5%;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: linear-gradient(180deg, #f3f5f8 0%, #ffffff 100%);
    border: 2px solid #ffffff;
    box-sizing: border-box;
    box-shadow: 8px 8px 20px rgba(61, 72, 93, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    .img {
      width: 6px;
      height: 10px;
    }
  }
  .swiper-button-next {
    margin-right: 5%;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: linear-gradient(180deg, #f3f5f8 0%, #ffffff 100%);
    border: 2px solid #ffffff;
    box-sizing: border-box;
    box-shadow: 8px 8px 20px rgba(61, 72, 93, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    .img {
      width: 6px;
      height: 10px;
    }
  }
  .swiper-slide-img {
    cursor: pointer;
    width: 100%;
  }
  .lb1 {
    position: relative;
    width: 100%;
    min-width: 1420px;
    height: 100%;
    // background-image: url("@/assets/lbbg1.png") ;
    background-size: 100%;
    background-repeat: no-repeat;
    .swiper-slide-img {
      width: 100%;
    }
    .text-box {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      width: 1420px;
      top: 25%;
      .p1 {
        font-weight: 700;
        font-size: 52px;
        line-height: 75px;
        color: #1a1a1a;
        margin-bottom: 12px;
      }
      .p2 {
        font-size: 20px;
        line-height: 32px;
        color: #6c727b;
      }
      .btn {
        margin-top: 40px;
        font-size: 20px;
        cursor: pointer;
        width: 164px;
        height: 54px;
        text-align: center;
        line-height: 54px;
        color: #fff;
        border-radius: 6px;
        background: #336fff;
        box-shadow: 8px 8px 20px rgba(55, 99, 170, 0.1);
      }
      .btn:hover {
        background: #5c8cff;
      }
    }
  }
  .lb2 {
    position: relative;
    width: 100%;
    min-width: 1420px;
    height: 100%;
    // background-image: url("@/assets/lbbg1.png") ;
    background-size: 100%;
    background-repeat: no-repeat;
    .swiper-slide-img {
      width: 100%;
    }
    .text-box {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      width: 1420px;
      top: 25%;
      .p1 {
        font-weight: 700;
        font-size: 52px;
        line-height: 75px;
        color: #1a1a1a;
        margin-bottom: 12px;
      }
      .p2 {
        font-size: 20px;
        line-height: 32px;
        color: #6c727b;
      }
      .btn {
        margin-top: 40px;
        font-size: 20px;
        cursor: pointer;
        width: 164px;
        height: 54px;
        text-align: center;
        line-height: 54px;
        color: #fff;
        border-radius: 6px;
        background: #336fff;
        box-shadow: 8px 8px 20px rgba(55, 99, 170, 0.1);
      }
      .btn:hover {
        background: #5c8cff;
      }
    }
  }
  .lb3 {
    position: relative;
    width: 100%;
    min-width: 1420px;
    height: 100%;
    // background-image: url("@/assets/lbbg1.png") ;
    background-size: 100%;
    background-repeat: no-repeat;
    .swiper-slide-img {
      width: 100%;
    }
    .text-box {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      width: 1420px;
      top: 25%;
      .p1 {
        font-weight: 700;
        font-size: 52px;
        line-height: 75px;
        color: #1a1a1a;
        margin-bottom: 12px;
      }
      .p2 {
        font-size: 20px;
        line-height: 32px;
        color: #6c727b;
      }
      .btn {
        margin-top: 40px;
        cursor: pointer;
        width: 164px;
        height: 54px;
        font-size: 20px;
        text-align: center;
        line-height: 54px;
        color: #fff;
        border-radius: 6px;
        background: #336fff;
        box-shadow: 8px 8px 20px rgba(55, 99, 170, 0.1);
      }
      .btn:hover {
        background: #5c8cff;
      }
    }
  }
  // /deep/ .slick-slide .i_carousel_item {
  //   width: 100%;
  //   height: 560px;
  //   img {
  //     width: 100%;
  //     height: 100%;
  //     // object-fit: cover;
  //   }
  // }
  // /deep/ .slick-dots li button {
  //   background: gray;
  // }
  // /deep/ .slick-dots li.slick-active button {
  //   background: #3d60dd !important;
  // }
}
.case-box {
  width: 100%;
  height: 720px;
  background: #f6f7fb;
  padding-top: 150px;
  position: relative;
  z-index: 1;
  .title-box {
    width: 1420px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: -63px;
    z-index: 2;
    display: flex;

    .titie-text {
      box-sizing: border-box;
      width: 286px;
      height: 126px;
      padding: 10px 20px 20px 20px;
      background: linear-gradient(180deg, #f3f5f8 0%, #ffffff 100%);
      border: 2px solid #ffffff;
      box-shadow: 8px 8px 20px rgba(55, 99, 170, 0.1);
      border-radius: 10px;
      margin-right: 20px;
      cursor: pointer;
      transition: all 0.2s;
      transform: translateY(0);
      &:hover {
        transition: all 0.2s;
        transform: translateY(-6px);
      }

      .titie-top {
        width: 245px;
        height: 48px;
        display: flex;
        align-items: center;
        .img {
          width: 36px;
          height: 36px;
          margin-left: 6px;
        }
        .span {
          font-size: 20px;
          line-height: 26px;
          color: #292929;
          margin-left: 26px;
        }
      }
      .titie-bottom {
        padding-left: 6px;
        font-size: 14px;
        line-height: 24px;
        color: #7e8fad;
      }
    }
  }
  .case-text {
    text-align: center;
    margin-bottom: 50px;
    .pi1 {
      font-size: 28px;
      line-height: 48px;
      color: #292929;
      margin-bottom: 0;
    }
    .p2 {
      margin-top: 12px;
      font-size: 16px;
      line-height: 22px;
      color: #3d485d;
    }
  }
  @keyframes loading {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
  .img-box {
    width: 1000px;
    position: absolute;
    z-index: -1;
    left: 50%;
    transform: translateX(-50%);
    .img {
      animation: loading 60s infinite linear;
      width: 1000px;
      height: 1000px;
    }
  }
  .client-box {
    display: flex;
    justify-content: space-between;
    width: 1420px;
    margin: 0 auto;
    height: 310px;
    .client-righ {
      width: 104px;
      height: 310px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .righ-text {
        .text1 {
          margin-bottom: 9px;
          font-size: 37px;
          line-height: 40px;
          color: #3d485d;
        }
        .btn1 {
          width: 68px;
          height: 22px;
          text-align: center;
          line-height: 22px;
          border: 1px solid #798496;
          border-radius: 2px;
          color: #3d485d;
          font-size: 12px;
        }
      }
    }
    .client-left {
      position: relative;
      .City-box {
        display: flex;
        .city {
          width: 82px;
          height: 32px;
          background: linear-gradient(
            116.72deg,
            #e5eaf1 29.91%,
            #ffffff 90.79%
          );
          box-shadow: 6px 6px 20px rgba(55, 99, 170, 0.11);
          border-radius: 6px;
          font-size: 13px;
          line-height: 32px;
          text-align: center;
          color: #3d485d;
          margin-right: 30px;
          cursor: pointer;
          &.active {
            position: relative;
            z-index: 2;
            width: 84px;
            height: 42px;
            background: #f6f9fb;
            box-shadow: inset 0px 2px 0px #ffffff, inset -2px 0px 0px #ffffff,
              inset 2px 0px 0px #ffffff;
            border-radius: 6px 6px 0px 0px;
            color: #0052d9;
          }
        }
      }
      .city-area {
        position: absolute;
        z-index: 1;
        left: 0;
        top: 40px;
        width: 895px;
        height: 264px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #f6f9fb;
        border: 2px solid #ffffff;
        box-sizing: border-box;
        box-shadow: 8px 8px 20px rgba(55, 99, 170, 0.1);
        border-radius: 0px 6px 6px 6px;
        padding: 24px 8px 24px 30px;
        .area-right {
          width: 306px;
          height: 200px;
          .img {
            width: 100%;
            height: 100%;
          }
        }
        .margin40 {
          margin-right: 40px;
        }
        .area-left {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          flex-direction: column;
          .area-text {
            margin-bottom: 8px;
            font-size: 13px;
            line-height: 24px;
            color: #000000;
          }
          .big {
            width: 190px;
          }
          .small {
            width: 140px;
          }
        }
      }
    }
  }
}
.plan-box {
  position: relative;
  z-index: 1;
  width: 100%;
  min-width: 120px;
  height: 732px;
  background: #ffffff;
  padding-top: 160px;
  .plan-text {
    text-align: center;
    margin-bottom: 50px;
    .p1 {
      font-size: 28px;
      line-height: 48px;
      color: #292929;
      margin-bottom: 0;
    }
    .p2 {
      margin-top: 12px;
      font-size: 16px;
      line-height: 22px;
      color: #3d485d;
    }
  }

  .swiper-button-prev {
    margin-left: -5%;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    // background: linear-gradient(180deg, #f3f5f8 0%, #ffffff 100%);
    background: #f76262;
    border: 2px solid #ffffff;
    box-sizing: border-box;
    box-shadow: 8px 8px 20px rgba(61, 72, 93, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    .img {
      width: 6px;
      height: 10px;
    }
  }
  .swiper-button-next {
    margin-right: 5%;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: linear-gradient(180deg, #f3f5f8 0%, #ffffff 100%);
    border: 2px solid #ffffff;
    box-sizing: border-box;
    box-shadow: 8px 8px 20px rgba(61, 72, 93, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    .img {
      width: 6px;
      height: 10px;
    }
  }
  .swiper-img-box {
    position: absolute;
    top: -68px;
    width: 75%;
    z-index: 5;
    left: 50%;
    transform: translateX(-50%);
    height: 136px;
    background: linear-gradient(180deg, #f3f5f8 0%, #ffffff 100%);
    border: 2px solid #ffffff;
    box-sizing: border-box;
    box-shadow: 8px 8px 20px rgba(55, 99, 170, 0.1);
    border-radius: 10px;
    padding-left: 50px;
    .swiper-slide {
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .img {
        width: 80px;
        height: 80px;
        margin: 0 20px;
      }
      .span {
        font-size: 13px;
        line-height: 20px;
        color: #3d485d;
      }
    }
  }
  .partnerList {
    width: 1420px;
    height: 132px;
    overflow: hidden;
    position: absolute;
    top: -68px;
    z-index: 5;
    left: 50%;
    transform: translateX(-50%);
    height: 136px;
    background: linear-gradient(180deg, #f3f5f8 0%, #ffffff 100%);
    border: 2px solid #ffffff;
    box-sizing: border-box;
    box-shadow: 8px 8px 20px rgba(55, 99, 170, 0.1);
    border-radius: 10px;
    .partner-box {
      width: 2840px;
      height: 132px;
      overflow: hidden;
      animation: move 12s linear infinite normal;
      display: flex;
      align-content: center;
      flex-wrap: nowrap;
      .partner1 {
        width: 120px;
        height: 132px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .img {
          width: 80px;
          height: 80px;
        }
        .span {
          font-size: 13px;
          line-height: 20px;
          color: #3d485d;
        }
      }
    }
  }
  @keyframes move {
    0% {
      transform: translateX(0px);
    }
    100% {
      transform: translateX(-1420px);
    }
  }

  .swiper-box2 {
    width: 1420px;
    margin: 0 auto;
    display: flex;
    .swiper-slide {
      background: #f8f9fb;
      border: 2px solid #eff5ff;
      // box-shadow: 0px 0px 20px rgba(55, 99, 170, 0.1);
      border-radius: 6px;
      width: 400px !important;
      overflow: hidden;
      height: 320px;
      margin-right: 16px;
      .img {
        width: 400px;
        height: 252px;
      }
      .txt {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 400px;
        height: 68px;
        font-size: 20px;
        line-height: 26px;
        color: #222222;
      }
    }
  }
}
.app-box {
  width: 100%;
  height: 796px;
  background: linear-gradient(180deg, #eef5ff 0%, rgba(255, 255, 255, 0) 100%);
  padding: 80px 0;
  font-size: 30px;
  line-height: 38px;
  text-align: center;
  color: #2a2a2a;
  .app-table-list {
    width: 1200px;
    height: 48px;
    border-bottom: 1px solid #e2ecff;
    margin: 35px auto;
    display: flex;
    align-items: center;
    justify-content: space-evenly;

    .app-table-box {
      display: flex;
      align-items: center;
      padding: 8px;
      height: 48px;
      cursor: pointer;
      position: relative;

      .table-img {
        width: 32px;
        height: 32px;
        margin-right: 8px;
      }
      .span-t {
        font-size: 16px;
        line-height: 24px;
        color: #9ba7ba;
      }
      &.active {
        .span-t {
          color: #336fff;
        }
      }
    }
    .app-table-box:before {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      content: "";
      width: 0;
      height: 2px;
      background-color: #006cff;
      transition: width 0.3s;
    }
    .active:before {
      width: 100%;
    }
  }
  .app-item-list {
    margin: 0 auto;
    margin-top: 40px;
    width: 1200px;
    position: relative;

    .app-item-box {
      position: absolute;
      left: 0;
      top: 0;
      width: 1200px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-right: 40px;
      &.active {
        z-index: 99;
        .item-img {
          opacity: 1;
          transform: translateX(0);
        }
      }

      .item-img {
        width: 540px;
        height: 480px;
        margin-right: 112px;
        opacity: 0;
        transform: translateX(40px);
        transition: all 0.3s;
      }

      .app-item-right {
        width: 508px;
        height: 250px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        opacity: 0;
        transform: translateX(40px);
        .title-item {
          opacity: 0;
          transform: translateX(40px);
          font-size: 24px;
          line-height: 32px;
          color: #222222;
        }
        .span-list {
          opacity: 0;
          transform: translateX(40px);
          width: 100%;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          .span-item-box {
            width: 254px;
            display: flex;
            align-items: center;
            margin-bottom: 16px;
            .yuan {
              width: 8px;
              height: 8px;
              /* 官网标椎蓝 */
              border: 2px solid #336fff;
              border-radius: 4px;
              margin-right: 16px;
            }
            .txt {
              font-size: 14px;
              line-height: 22px;
              color: #69717e;
            }
          }
        }
        .xian {
          width: 423px;
          height: 2px;
          border: 1px solid #e2ecff;
          opacity: 0;
          transform: translateX(40px);
        }
        .btn-box {
          display: flex;
          align-items: center;
          opacity: 0;
          transform: translateX(40px);
          .btn1 {
            padding: 0px 34px;
            width: 136px;
            height: 48px;
            background: #336fff;
            border: 1px solid #336fff;
            border-radius: 40px;
            font-size: 16px;
            line-height: 48px;
            color: #ffffff;
            margin-right: 24px;
            cursor: pointer;
          }
          .btn2 {
            padding: 0px 34px;
            width: 136px;
            height: 48px;
            border: 1px solid #336fff;
            border-radius: 40px;
            font-size: 16px;
            line-height: 48px;
            color: #336df6;
            cursor: pointer;
          }
        }
      }

      &.active {
        opacity: 1;
        .app-item-right {
          opacity: 1;
          .title-item {
            opacity: 1;
            transition: all 300ms ease-out 80ms;
            transform: translateX(0);
          }
          .span-list {
            opacity: 1;
            transition: all 300ms ease-out 140ms;
            transform: translateX(0);
          }
          .xian {
            opacity: 1;
            transition: all 300ms ease-out 140ms;
            transform: translateX(0);
          }
          .btn-box {
            opacity: 1;
            transition: all 300ms ease-out 180ms;
            transform: translateX(0);
          }
        }
      }
    }
  }
}

.znjzt-box {
  width: 100%;
  // height: 720px;
  // background-image: url('~@/assets/znjzt.png');
  // background-size: cover;
  // background-size: 100% 100%;
  .znjzt-img {
    width: 100%;
    // height: 720px;
  }
}
.Introduction-box {
  position: relative;
  z-index: 3;
  width: 100%;
  min-width: 1420px;
  height: 502px;
  background: #f6f7fb;
  padding-top: 44px;
  .Introduction-text {
    text-align: center;
    .p1 {
      font-size: 28px;
      line-height: 48px;
      color: #292929;
      margin-bottom: 0;
    }
    .p2 {
      margin-top: 12px;
      font-size: 16px;
      line-height: 22px;
      color: #3d485d;
    }
  }
  .title-Introduction-box {
    margin: 0 auto;
    width: 1420px;
    margin-top: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .Introduction1 {
      position: relative;
      width: 452px;
      height: 260px;
      border-radius: 4px;
      .img {
        width: 100%;
        height: 100%;
      }
      .saas-box {
        position: absolute;
        left: 0;
        bottom: 0;
        top: 0;
        right: 0;
        padding: 20px;
        .saas1-box {
          width: 245px;
          height: 100px;
        }
        .saas1 {
          font-size: 20px;
          line-height: 28px;
          margin-bottom: 10px;
        }
        .saas2 {
          font-size: 13px;
          line-height: 22px;
          color: #3d485d;
        }
        .btn-box {
          margin-top: 18px;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          .btn1 {
            width: 130px;
            height: 40px;
            background: #ffffff;
            box-shadow: 8px 8px 20px rgba(55, 99, 170, 0.1);
            border-radius: 4px;
            text-align: center;
            line-height: 40px;
            margin-bottom: 18px;
            color: #3d485d;
            cursor: pointer;
            &:hover {
              background: #ffffff;
              box-shadow: inset 12px 12px 30px #e8ecf0;
              color: #336fff;
            }
          }
        }
      }
    }
  }
}
.Serve-box {
  width: 100%;
  height: 572px;
  padding: 44px 0 78px;
  box-sizing: border-box;
  .Serve-text {
    text-align: center;
    .p1 {
      font-size: 28px;
      line-height: 48px;
      color: #292929;
      margin-bottom: 0;
    }
    .p2 {
      margin-top: 12px;
      font-size: 16px;
      line-height: 22px;
      color: #3d485d;
    }
  }
  .serve-box-bom {
    width: 1420px;
    margin: 40px auto 0;
    display: flex;
    justify-content: space-between;
    .serve-text {
      width: 310px;
      height: 308px;
      padding: 20px;
      border-radius: 0px;
      box-shadow: 0px 0px 0px rgba(55, 99, 170, 0.1);
      transition: width 0.2s;
      .im {
        width: 54px;
        height: 54px;
        margin: 0 auto;
        .img {
          width: 100%;
          height: 100%;
        }
      }
      .title-t {
        font-size: 20px;
        line-height: 30px;
        color: #666;
        text-align: center;
      }
      .xian1 {
        margin: 0 auto;
        width: 68px;
        height: 0.5px;
        background: #33333340;
        margin-bottom: 14px;
        margin-top: 24px;
      }
      .span1-t {
        display: block;
        text-align: center;
        font-size: 16px;
        line-height: 30px;
        color: #999;
        margin-top: 10px;
      }
      .span2-t {
        opacity: 0;
        font-size: 15px;
        line-height: 30px;
        text-align: left;
        margin-top: 10px;
      }
      .span3-t {
        margin-top: 0px;
      }
      &:hover {
        width: 490px;
        height: 328px;
        padding: 20px;
        background: #fbfcff;
        box-shadow: 8px 8px 20px rgba(55, 99, 170, 0.1);
        border-radius: 6px;
        transition: width 0.2s;
        .xian1 {
          text-align: center;
          width: 450px;
          height: 1px;
          background: #33333340;
          margin-bottom: 14px;
          margin-top: 24px;
        }
        .span1-t {
          display: none;
          text-align: center;
          font-size: 16px;
          line-height: 30px;
          color: #999;
          margin-top: 10px;
        }
        .span2-t {
          font-size: 15px;
          line-height: 30px;
          text-align: left;
          opacity: 1;
          margin-top: 10px;
        }
        .span3-t {
          margin-top: 0px;
        }
      }
    }
  }
}
.tryout-box {
  width: 100%;
  height: auto;
  position: relative;
  .img {
    width: 100%;
    height: 280px;
  }
  .box {
    width: 100%;
    position: absolute;
    left: 0;
    top: 38px;
    padding: 0 250px;
    display: flex;
    justify-content: space-between;
    .tryout-text {
      margin-top: 26px;
      width: 448px;

      .div1 {
        font-size: 28px;
        line-height: 36px;
        color: #fff;
      }
      .div-btn {
        width: 144px;
        height: 48px;
        background: #ffffff;
        box-shadow: 4px 4px 20px rgba(55, 99, 170, 0.16);
        cursor: pointer;
        height: 48px;
        margin-top: 3%;
        text-align: center;
        line-height: 48px;
        filter: drop-shadow(8px 8px 20px rgba(55, 99, 170, 0.1));
        border-radius: 6px;
        font-size: 20px;
        color: #242933;
      }
    }
    .consultation {
      width: 531px;
      height: 204px;
      background: linear-gradient(
        180deg,
        rgba(243, 245, 248, 0.9) 0%,
        rgba(255, 255, 255, 0.9) 100%
      );
      border: 2px solid #ffffff;
      backdrop-filter: blur(4px);
      border-radius: 8px;
      padding: 32px;
      display: flex;
      align-items: center;
      .consultation-left {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .txt1 {
          font-weight: 500;
          font-size: 28px;
          line-height: 36px;
          color: #336fff;
        }
        .txt3 {
          font-weight: 400;
          font-size: 14px;
          line-height: 22px;
          color: #3d485d;
        }
        .txt2 {
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
          color: #3d485d;
        }
        .txt4 {
          font-weight: 500;
          font-size: 20px;
          line-height: 28px;
          color: #336fff;
        }
      }
      .consultation-right {
        margin-left: 32px;
        .img {
          width: 120px;
          height: 120px;
        }
      }
    }
  }
}

.advantage {
  width: 100%;
  min-width: 1420px;
  height: 478px;
  padding: 64px 0px;
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  .advantage-tit {
    color: #353535;
    font-weight: 500;
    font-size: 30px;
  }
  .advantage-content {
    width: 1200px;
    height: 284px;
    box-sizing: border-box;
    display: flex;
    .advantage-item {
      width: 300px;
      height: 284px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      //   justify-content: space-around;
      .advantage-item-icon {
        margin-top: 30px;
        width: 100px;
        height: 100px;
        overflow: hidden;
        img {
          width: 100px;
          height: 100px;
        }
      }
      .advantage-item-tit {
        margin-top: 30px;
        text-align: center;
        color: #353535;
        font-weight: 350;
        font-size: 20px;
      }
      .advantage-item-tip {
        margin-top: 20px;
        text-align: center;
        width: 240px;
        height: 48px;
        font-weight: 350;
        font-size: 14px;
        color: #666666;
      }
    }
  }
}
.productLine {
  color: #ffffff;
  width: 100%;
  min-width: 1420px;
  height: 570px;
  background: url("~@/assets/productLine.png");
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .productLine-tit {
    margin-top: 64px;
    color: #ffffff;
    font-size: 30px;
    font-weight: 500;
    text-align: center;
  }
  .productLine-content {
    margin-top: 46px;
    display: flex;
    align-items: center;
    justify-content: center;
    .productLine-content-left {
      padding: 15px 0;
      width: 134px;
      height: 360px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      .productLine-content-activite {
        font-weight: 500 !important;
        font-size: 26px !important;
      }
      .productLine-content-left-item {
        cursor: pointer;
        width: 100%;
        height: 80px;
        line-height: 80px;
        text-align: center;
        box-sizing: border-box;
        font-size: 20px;
        font-weight: 350;
      }
    }
    .productLine-content-line {
      width: 9px;
      height: 360px;
      margin-left: 18px;
      overflow: hidden;
      img {
        width: 9px;
        height: 360px;
      }
    }
    .productLine-content-right {
      margin-left: 39px;
      width: 1000px;
      height: 258px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .productLine-content-right-tit {
        font-weight: 500;
        font-size: 26px;
      }
      .productLine-content-right-content {
        display: flex;
        .productLine-content-right-content-item {
          width: 200px;
          height: 196px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-around;
          .productLine-content-right-content-item-icon {
            width: 80px;
            height: 80px;
            overflow: hidden;
            img {
              width: 80px;
              height: 80px;
            }
          }
          .productLine-content-right-content-item-word {
            font-weight: 350;
            font-size: 16px;
          }
        }
      }
    }
  }
}
.applicableScene {
  width: 100%;
  min-width: 1420px;
  height: 704px;
  padding: 44px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .applicableScene-tit {
    text-align: center;
    font-weight: 500;
    font-size: 30px;
    color: #353535;
  }
  .applicableScene-content {
    width: 1200px;
    height: 260px;
    display: flex;
    margin-top: 30px;
    .applicableScene-item {
      width: 285px;
      height: 260px;
      box-sizing: border-box;
      border: 1px solid #cccccc;
      border-radius: 10px;
      margin-right: 20px;
      overflow: hidden;
      .applicableScene-item-icon {
        width: 283px;
        height: 194px;
        overflow: hidden;
        img {
          width: 283px;
          height: 194px;
          color: #353535;
        }
      }
      .applicableScene-item-word {
        text-align: center;
        font-weight: 350;
        font-size: 20px;
        line-height: 64px;
        color: #353535;
      }
    }
    .applicableScene-item:last-child {
      margin-right: 0;
    }
  }
}
.accumulation {
  width: 100%;
  min-width: 1420px;
  height: 528px;
  padding: 44px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .accumulation-content {
    position: relative;
    width: 1200px;
    height: 440px;
    display: flex;
    flex-wrap: wrap;
    .accumulation-item {
      //   width: 291px;
      width: 50%;
      height: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      //   margin-top: 50px;
      //   margin-left: 134px;
      .accumulation-item-left {
        width: 120px;
        height: 120px;
        overflow: hidden;
        img {
          width: 120px;
          height: 120px;
        }
      }
      .accumulation-item-right {
        margin-left: 40px;
        // width: 131px;
        height: 106px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .accumulation-item-word {
          font-weight: 350;
          font-size: 26px;
          color: #353535;
        }
        .accumulation-item-focus {
          font-weight: 500;
          font-size: 48px;
          color: #3d60dd;
        }
      }
    }
    .accumulation-line {
      position: absolute;
      width: 180px;
      height: 10px;
      //   left: calc(50% - 180px / 2 + 95px);
      //   top: calc(50% - 10px / 2 - 215px);
      left: calc(50% - 90px);
      top: calc(50% - 135px);
      background: #3d60dd;
      opacity: 0.2;
      border-radius: 28px;
      transform: rotate(90deg);
    }
    .accumulation-line2 {
      position: absolute;
      width: 560px;
      height: 10px;
      left: calc(50% - 600px);
      top: calc(50% - 5px);
      background: #3d60dd;
      opacity: 0.2;
      border-radius: 28px;
    }
    .accumulation-line3 {
      position: absolute;
      width: 180px;
      height: 10px;
      left: calc(50% - 90px);
      top: calc(50% + 125px);
      background: #3d60dd;
      opacity: 0.2;
      border-radius: 28px;
      transform: rotate(90deg);
    }
    .accumulation-line4 {
      position: absolute;
      width: 560px;
      height: 10px;
      left: calc(50% + 40px);
      top: calc(50% - 5px);
      background: #3d60dd;
      opacity: 0.2;
      border-radius: 28px;
    }
  }
}
.partner {
  width: 100%;
  min-width: 1420px;
  height: 530px;
  padding: 44px 44px 64px 44px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .partner-tit {
    font-weight: 500;
    font-size: 30px;
    color: #353535;
    text-align: center;
  }
  .partner-content {
    margin-top: 50px;
    width: 1200px;
    height: 143px;
    display: flex;
    .partner-item {
      width: 208px;
      height: 143px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      margin-right: 40px;
      &:last-child {
        margin-right: 0;
      }
      .partner-item-icon {
        width: 100px;
        height: 100px;
        overflow: hidden;
        img {
          width: 100px;
          height: 100px;
        }
      }
      .partner-item-word {
        text-align: center;
        font-weight: 350;
        font-size: 16px;
        color: #353535;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/index.vue